import { BubbleMenu } from '@tiptap/react';
import { Editor } from '@tiptap/core';

import { TableToolsOptions } from './tableToolsOptions';
import { applyBubbleBoundary, bubblePopperOptions } from '../utils';

type TableToolsProps = {
  editor: Editor | null;
  withViewportBoundaries?: boolean;
};

export function TableTools({
  editor,
  withViewportBoundaries,
}: TableToolsProps) {
  if (!editor) return null;

  const viewportBoundaryOptions = withViewportBoundaries
    ? {
        popperOptions: bubblePopperOptions(editor),
        onShow: applyBubbleBoundary(editor),
      }
    : {};

  return (
    <BubbleMenu
      pluginKey="tableBubbleMenu"
      className="tooltip-shadow"
      editor={editor}
      tippyOptions={{
        duration: 100,
        placement: 'top',
        maxWidth: 'none',
        ...viewportBoundaryOptions,
      }}
      shouldShow={({ editor: currentEditor }) => {
        if (!currentEditor.isEditable) return false;
        return currentEditor.isActive('table');
      }}
    >
      <TableToolsOptions editor={editor} />
    </BubbleMenu>
  );
}
